<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Список событий </span>

        <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
          color="var(--app-dark-blue-1)">mdi-information</v-icon>
      </div>
      <v-btn @click="goToCreate" class="button-accept">
        + Создать событие
      </v-btn>
      <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
        <v-card min-width="300px" min-height="100px">
          <div class="menu-container">
            <div class="menu-container-title">«Список событий»</div>
            <div class="menu-container-text">
              Основной список отображающийся во вкладке меню мобильного
              приложения "События"
            </div>
            <div class="menu-container-title">
              Иконка
              <v-icon small color="#929292"> mdi-bell </v-icon>
            </div>
            <div class="menu-container-text">
              При отображении колокольчика около даты - отправиться/отправлялось
              push-уведомление при публикации и за неделю до события
            </div>
          </div>
        </v-card>
      </v-menu>
    </div>
    <div class="table-container">
      <v-data-table :footer-props="{
        itemsPerPageOptions: [10, 25, 50],
        'items-per-page-text': '',
      }" :headers="tableHeaders" :items="events" class="elevation-0 main-table"
        :items-per-page="optionTable.itemsPerPage" :page="optionTable.page" hide-default-header
        :server-items-length="optionTable.serverItemsLength" @pagination="tableChange" ref="sortableTable" fixed-header>
        <template v-slot:header>
          <thead>
            <tr>
              <th v-for="(s, index) in tableHeaders" :key="index">
                <div style="margin-left: 24px" v-if="s.text == 'Дата публикации'">
                  {{ s.text }}
                </div>
                <div style="max-width: 100px !important" v-else-if="s.text == 'Порядок отображения'">
                  {{ s.text }}
                </div>
                <div v-else>
                  {{ s.text }}
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template slot="body">
          <draggable :list="events" tag="tbody" @end="endDrag" :move="checkMove"
            :style="moveItems ? 'pointer-events: none;' : ''">
            <tr v-for="(item, index) in events" :key="index" @click="goToDetail(item)" style="height: auto">
              <td>
                <v-icon small style="cursor: pointer" :disabled="moveItems ? true : false">
                  mdi-menu
                </v-icon>
              </td>

              <td v-if="item.toHead">
                <v-icon small> mdi-star </v-icon>
              </td>
              <td v-else>
                {{ index + sortedNumbers[0] }}
              </td>
              <td>
                {{ item.name }}
              </td>
              <td>
                {{ item.place || "" }}
              </td>
              <td>
                {{ formatEventType(item.eventType) }}
              </td>

              <td>
                <span v-if="item.hideEventTime">
                  {{ item.plannedDate | moment("DD.MM.YYYY") }}
                </span>
                <span v-else>
                  {{ item.plannedDate | moment("DD.MM.YYYY HH:mm") }}
                </span>
              </td>
              <td v-if="item.toSendPush">
                <div class="d-flex align-center">
                  <v-icon small style="margin-right: 8px"> mdi-bell </v-icon>
                  {{ item.datePublish | moment("DD.MM.YYYY HH:mm") }}
                </div>
              </td>
              <td v-else>
                <div class="d-flex align-center">
                  <div style="width: 24px"></div>
                  {{ item.datePublish | moment("DD.MM.YYYY HH:mm") }}
                </div>
              </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    events: [],
    sortedNumbers: [],
    moveItems: false,
    selectedDrag: "",
    optionTable: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
    tableHeaders: [
      {
        text: "",
        sortable: false,
      },
      {
        text: "Порядок отображения",
        value: "",
        sortable: false,
      },
      {
        text: "Заголовок",
        sortable: false,
        value: "name",
      },

      {
        text: "Место",
        sortable: false,
        value: "place",
      },
      {
        text: "Тип события",
        sortable: false,
        value: "eventType",
      },
      {
        text: "Дата события",
        sortable: false,
        value: "plannedDate",
      },
      {
        text: "Дата публикации",
        sortable: false,
        value: "datePublish",
      },
    ],
  }),
  methods: {
    checkLocal() {
      const localOptionTable = JSON.parse(
        localStorage.getItem("eventsOptionTable")
      );
      if (localOptionTable) {
        this.optionTable = localOptionTable;
      }
    },
    openInfo(e) {
      e.preventDefault();

      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },
    goToCreate() {
      this.$router.push({ name: "CreateEvent" });
    },
    goToDetail(item) {
      this.$router.push({ name: "DetailEvent", params: { id: item.id } });
    },
    getEvents() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/event/list",
          {
            optionTable: this.optionTable,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.events = res.data.items;
          const numberOnly = this.events.map((item) => {
            return item.index;
          });
          this.sortedNumbers = numberOnly.sort((a, b) => {
            return a - b;
          });
          this.optionTable = res.data.optionTable;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    tableChange(data) {
      this.optionTable.page = data.page;
      this.optionTable.itemsPerPage = data.itemsPerPage;
      localStorage.setItem(
        "eventsOptionTable",
        JSON.stringify(this.optionTable)
      );
      this.$nextTick(() => {
        this.getEvents();
      });
    },
    endDrag(evt) {
      this.moveItems = true;
      this.$axios
        .put(
          this.$store.getters.apiAdminPanelV2 + "/event/sort",
          {
            eventId: this.selectedDrag,
            index:
              this.optionTable.itemsPerPage * (this.optionTable.page - 1) +
              evt.newIndex +
              1,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.getEvents();
          this.moveItems = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    checkMove(evt) {
      this.selectedDrag = evt.draggedContext.element.id;
    },
    formatEventType(type) {
      const eventTypeMap = {
        online_offline: "Онлайн/Оффлайн",
        online: "Онлайн",
        offline: "Оффлайн",
        "Онлайн/Оффлайн": "Онлайн/Оффлайн",
        Онлайн: "Онлайн",
        Оффлайн: "Оффлайн",
      };

      return eventTypeMap[type] || "Онлайн/Оффлайн";
    },
  },
  created() {
    this.checkLocal();
    this.getEvents();
  },
};
</script>
<style lang="scss" scoped>
.table-container {
  height: calc(100vh - 190px);

  .main-table {
    height: calc(100vh - 190px) !important;
    min-height: calc(100vh - 190px) !important;
    max-height: calc(100vh - 190px) !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>
